import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const UsersApi = createApi({
  reducerPath: "UsersApi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    //Auth API-------------------------------------------------------
    getAuthData: builder.query({
      query: (id) => ({
        url: `get_single_user_auth_detail/${id}`,
        transformResponse: (response) => response?.data || [],
      }),
    }),

    //Start Login API's --------------------------------------------
    getAllLoginHistoryData: builder.query({
      query: () => "get_all_login_history",
      transformResponse: (response) => response?.data || [],
    }),

    getLoginUserData: builder.query({
      query: () => "get_login_user_data",
      transformResponse: (response) => response?.data || [],
    }),
    //END Login API's --------------------------------------------

    //Start User API's----------------------------------------------
    addUser: builder.mutation({
      query: (adduser) => ({
        url: "add_user",
        method: "POST",
        body: adduser,
      }),
    }),
    addSendUserMail: builder.mutation({
      query: (addsendmail) => ({
        url: "add_send_user_mail",
        method: "POST",
        body: addsendmail,
      }),
    }),
    getAllUserData: builder.query({
      query: () => "get_users",
      transformResponse: (response) => response?.data?.paginatedUsers,
    }),
    getAllUserDataWithPagination: builder.query({
      query: ({ limit, page, search, user_status, role }) => {
        let queryParams = [];

        if (limit !== undefined) queryParams.push(`limit=${limit}`);
        if (page !== undefined) queryParams.push(`page=${page}`);
        if (search !== undefined) queryParams.push(`search=${encodeURIComponent(search)}`);
        if (user_status !== undefined) queryParams.push(`user_status=${encodeURIComponent(user_status)}`);
        if (role !== undefined) queryParams.push(`role=${encodeURIComponent(role)}`);

        const queryString = queryParams.length > 0 ? `${queryParams.join("&")}` : "";

        return `/get_users?${queryString}`;
      },

      transformResponse: (response) => {
        const userData = response?.data?.paginatedUsers || response?.data || [];
        const pagination = response?.data?.pagination || {};

        return {
          users: userData,
          pagination,
        };
      },

      keepUnusedDataFor: 300,
    }),

    getUserById: builder.query({
      query: (id) => `get_single_user/${id}`,
      transformResponse: (response) => response,
    }),

    getFamilyById: builder.query({
      query: (id) => `get_single_family/${id}`,
      transformResponse: (response) => response?.data,
    }),
    getEducationById: builder.query({
      query: (id) => `get_single_education/${id}`,
      transformResponse: (response) => response?.data,
    }),

    editEducation: builder.mutation({
      query: (updateedu) => ({
        url: `update_education`,
        method: "PUT",
        body: updateedu,
      }),
    }),
    editFamily: builder.mutation({
      query: (updateedu) => ({
        url: `update_family`,
        method: "PUT",
        body: updateedu,
      }),
    }),

    deleteEducation: builder.mutation({
      query: (id) => ({
        url: `delete_education/${id}`,
        method: "DELETE",
      }),
    }),
    deleteFamily: builder.mutation({
      query: (id) => ({
        url: `delete_family/${id}`,
        method: "DELETE",
      }),
    }),

    addUserGenralInfo: builder.mutation({
      query: (addgen) => ({
        url: "add_user_for_general_information",
        method: "POST",
        body: addgen,
      }),
    }),

    getUserOtherDetails: builder.query({
      query: (id) => `get_user_other_fields/${id}`,
      transformResponse: (response) => response?.data,
    }),

    editUserGenralInfo: builder.mutation({
      query: ({ id, updateedu }) => ({
        url: `update_user_for_general_information/${id}`,
        method: "PUT",
        body: updateedu,
      }),
    }),
    editUserDoc: builder.mutation({
      query: (update) => ({
        url: `update_user_doc`,
        method: "PUT",
        body: update,
      }),
    }),
    editUserOtherDetails: builder.mutation({
      query: ({ id, update }) => ({
        url: `update_user_for_other_details/${id}`,
        method: "PUT",
        body: update,
      }),
    }),
    editUserBankDetails: builder.mutation({
      query: ({ id, update }) => ({
        url: `update_user_for_bank_details/${id}`,
        method: "PUT",
        body: update,
      }),
    }),
    editUserDocImage: builder.mutation({
      query: ({ update }) => ({
        url: `update_doc_user`,
        method: "PUT",
        body: update,
      }),
    }),
    updateUser: builder.mutation({
      query: (update) => ({
        url: `update_user`,
        method: "PUT",
        body: update,
      }),
    }),

    getSingleUserExp: builder.query({
      query: (id) => `get_single_user_experience/${id}`,
      transformResponse: (response) => response?.data,
    }),

    updateUserNew: builder.mutation({
      query: (update) => ({
        url: `update_usernew`,
        method: "PUT",
        body: update,
      }),
    }),
    updateUserOtherFieldData: builder.mutation({
      query: ({ id, update }) => ({
        url: `updateuserotherfielddata/${id}`,
        method: "PUT",
        body: update,
      }),
    }),

    getCocHistoryData: builder.query({
      query: (id) => `get_coc_history/${id}`,
      transformResponse: (response) => response?.data,
    }),

    getCocData: builder.query({
      query: () => `newcoc`,
      transformResponse: (response) => response?.data,
    }),
    getCocByIdData: builder.query({
      query: (id) => `newcoc/${id}`,
      transformResponse: (response) => response?.data,
    }),

    addCoc: builder.mutation({
      query: (addgen) => ({
        url: "newcoc",
        method: "POST",
        body: addgen,
      }),
    }),

    updateCocData: builder.mutation({
      query: (update) => ({
        url: `newcoc`,
        method: "PUT",
        body: update,
      }),
    }),

    addLoginUser: builder.mutation({
      query: (addgen) => ({
        url: "login_user",
        method: "POST",
        body: addgen,
      }),
    }),

    //Start Document API's------------------------------------------------
    getAllDocs: builder.query({
      query: () => `get_all_docs`,
      transformResponse: (response) => response?.data,
    }),
    addDocument: builder.mutation({
      query: (addgen) => ({
        url: "add_doc",
        method: "POST",
        body: addgen,
      }),
    }),

    getDocById: builder.query({
      query: (id) => `get_doc/${id}`,
      transformResponse: (response) => response?.data,
    }),

    updateDocument: builder.mutation({
      query: (update) => ({
        url: `update_doc`,
        method: "PUT",
        body: update,
      }),
    }),

    //Timeline API's
    getTimeLineApi: builder.query({
      query: (id) => `get_user_time_line/${id}`,
      transformResponse: (response) => response,
    }),

    addGeneralUserInfo: builder.mutation({
      query: (formData) => ({
        url: "add_user_for_general_information",
        method: "POST",
        body: formData,
      }),
    }),

    checkLoginExists: builder.query({
      query: (generatedLoginId) => `check_login_exist/${generatedLoginId}`,
    }),

    getUserDocuments: builder.query({
      query: (userId) => `get_user_doc?user_id=${userId}`,
    }),

    imageToBase64: builder.query({
      query: (imageUrl) =>
        `image_to_base64?imageUrl=${encodeURIComponent(imageUrl)}`,
      transformResponse: (response) => response?.data,
    }),

    deleteFamilyMember: builder.mutation({
      query: (familyId) => ({
        url: `delete_family/${familyId}`,
        method: "DELETE",
      }),
    }),

    deleteEducationDetail: builder.mutation({
      query: (educationId) => ({
        url: `delete_education/${educationId}`,
        method: "DELETE",
      }),
    }),

    getLatestCoc: builder.query({
      query: () => "latest_newcoc",
    }),

    updateUserIdentityDetails: builder.mutation({
      query: (payload) => ({
        url: `update_user_identity_details`,
        method: "PUT",
        body: payload,
      }),
    }),

    updateUserOtherDetail: builder.mutation({
      query: (payload) => ({
        url: "update_user_other_detail",
        method: "PUT",
        body: payload,
      }),
    }),

    editDocumentOrder: builder.mutation({
      query: (body) => ({
        url: "edit_document_order",
        method: "PUT",
        body,
      }),
    }),

    getUserWfhdJoiningSummary: builder.query({
      query: (id) => `user_wfhd_joining_summary/${id}`,
    }),

    getAttendanceByUserId: builder.query({
      query: (user_id) => `get_attendance_by_userid/${user_id}`,
      transformResponse: (response) => response,
    }),

    updateUserExperience: builder.mutation({
      query: (payload) => ({
        url: "update_user_experience",
        method: "PUT",
        body: payload,
      }),
    }),

    deleteUserExperience: builder.mutation({
      query: (delet) => ({
        url: `delete_user_experience/${delet}`,
        method: "DELETE",
      }),
    }),

    getUserLoginFilter: builder.query({
      query: ({ start_date, end_date }) =>
        `get_login_user_data_with_date?start_date=${encodeURIComponent(
          start_date
        )}&end_date=${encodeURIComponent(end_date)}`,
      transformResponse: (response) => response?.data, // Use if your API wraps the actual data
    }),

    // logOut: builder.mutation({
    //   query: (addgen) => ({
    //     url: "log_out",
    //     method: "POST",
    //     body: addgen,
    //   }),
    // }),

    addSeparation: builder.mutation({
      query: (addgen) => ({
        url: "add_separation",
        method: "POST",
        body: addgen,
      }),
    }),
    addSendUserMailExtendDate: builder.mutation({
      query: (addgen) => ({
        url: "send_mail_for_extend_joining_date",
        method: "POST",
        body: addgen,
      }),
    }),

    rejoinUser: builder.mutation({
      query: (payload) => ({
        url: "rejoin_user",
        method: "PUT",
        body: payload,
      }),
    }),

    resetPassword: builder.mutation({
      query: (payload) => ({
        url: "reset_password",
        method: "POST",
        body: payload,
      }),
    }),

    //END User API's-----------------------------------------------
  }),
});

export const {
  // auth api
  useGetAuthDataQuery,

  //user api
  useAddUserMutation,
  useAddSendUserMailMutation,
  useGetAllUserDataQuery,
  useGetAllUserDataWithPaginationQuery,
  useGetUserByIdQuery,
  useGetFamilyByIdQuery,
  useGetEducationByIdQuery,
  useEditEducationMutation,
  useEditFamilyMutation,
  useDeleteEducationMutation,
  useDeleteFamilyMutation,
  useAddUserGenralInfoMutation,
  useGetUserOtherDetailsQuery,
  useEditUserGenralInfoMutation,
  useEditUserDocMutation,
  useEditUserOtherDetailsMutation,
  useEditUserBankDetailsMutation,
  useEditUserDocImageMutation,
  useUpdateUserMutation,
  useGetSingleUserExpQuery,
  useUpdateUserNewMutation,
  useGetUserByDeptIdQuery,
  useGetLoginUserDataQuery,
  useGetAllLoginHistoryDataQuery,
  useUpdateUserOtherFieldDataMutation,
  useGetCocHistoryDataQuery,
  useGetCocDataQuery,
  useAddCocMutation,
  useGetCocByIdDataQuery,
  useUpdateCocDataMutation,
  useAddLoginUserMutation,

  //Doc api-------
  useGetAllDocsQuery,
  useAddDocumentMutation,
  useGetDocByIdQuery,
  useUpdateDocumentMutation,

  //Timeline
  useGetTimeLineApiQuery,
  useAddGeneralUserInfoMutation,
  useLazyCheckLoginExistsQuery,
  useGetUserDocumentsQuery,
  useImageToBase64Query,
  useDeleteFamilyMemberMutation,
  useDeleteEducationDetailMutation,
  useGetLatestCocQuery,
  useUpdateUserIdentityDetailsMutation,
  useUpdateUserOtherDetailMutation,
  useEditDocumentOrderMutation,
  useGetUserWfhdJoiningSummaryQuery,
  useGetAttendanceByUserIdQuery,

  useUpdateUserExperienceMutation,
  useDeleteUserExperienceMutation,

  useGetUserLoginFilterQuery,
  // useLogOutMutation,

  useAddSeparationMutation,
  useAddSendUserMailExtendDateMutation,

  useRejoinUserMutation,

  useResetPasswordMutation,
} = UsersApi;

export default UsersApi;
